import { SelectChangeEvent, Grid, Select, OutlinedInput, MenuItem, Checkbox, ListItemText } from "@mui/material";
import { useState, useEffect } from "react";
import { FilterTitle } from "./FilterTitle";
import { handleCutStringHelper } from "../../../helpers/displayStringHelpers";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        },
    },
};

export interface SelectCheckmarksProps {
    title?: string,
    value: any[] | undefined,
    setValue: (values: any[]) => void
    type: any,
    prefix?: string
    source?: "VALUE" | "KEY" | "STRING"
    active?: boolean
}

const SelectCheckmarks: React.FC<SelectCheckmarksProps> = (props) => {

    const getTypeValues = (): string[] => {
        switch (props.source) {
            case "STRING":
                return props.type as string[]
            case "VALUE":
                return Object.values(props.type).map((e) => {return e}) as string[]
            case "KEY":
            default:
                return Object.keys(props.type).map((e) => {return e})
        }
    }

    const [values, setValues] = useState<string[]>((props.value as string[]) ?? []);

    useEffect(() => {
        setValues(props.value as string[] ?? [])
    }, [props.value])

    const handleChange = (event: SelectChangeEvent<string[]>, child: React.ReactNode) => {
        const { target: { value }} = event;
        if (typeof value === "string") {
            setValues([value])
            props.setValue([value])
        } else {
            setValues(value)
            props.setValue(value)
        }
    }

    const handleRenderValue = (str: string[]) => {
        if (str.length > 0) {
            return str.map(s => handleCutStringHelper(props.prefix, s)).join(', ')
        } else {
            return ""
        }
    }

    return (
        <Grid container style={{width: "100%", height: "100%", minWidth: "250px"}}>
            {props.title ?
                <Grid item xs={12}>
                    <FilterTitle style={{opacity: (props.active === undefined || props.active) ? "100%" : "50%"}}>
                        {props.title}
                    </FilterTitle>
                </Grid> : null
            }
            <Grid item xs={12}>
                <Select
                    disabled={props.active !== undefined? !props.active : false}
                    displayEmpty
                    style={{width: "100%", height: "100%"}}
                    value={values}
                    input={<OutlinedInput/>}
                    multiple
                    onChange={handleChange}
                    color="primary"
                    renderValue={handleRenderValue}
                    MenuProps={MenuProps}
                    inputProps={{"aria-label": "Without label"}}
                >
                    {getTypeValues().map((e, i) => (
                        <MenuItem key={i} value={e}>
                            <Checkbox checked={values.findIndex((v) => v === e) > -1} color="primary" />
                            <ListItemText primary={handleCutStringHelper(props.prefix, e)} />
                        </MenuItem>
                    ))}
                </Select>
            </Grid>
        </Grid>
    )
}

export default SelectCheckmarks